import { useEffect, useState } from "react";
import { tMsg } from "../ToastNotifications";
import apiAgent from "../../api/apiAgent";
import { IBaseInputProps, IDropdownOption } from "./Inputs";
import Select from "react-select";
import _ from "lodash";

export const ThemeSelector = (props: IBaseInputProps): JSX.Element => {
  const { name, value, className, onChange, required, disabled } = props;

  const [options, setOptions] = useState<IDropdownOption[]>([]);
  const fetchThemeOptions = async () => {
    try {
      const response = await apiAgent.DataType.getAll("themes");
      const getOptions = response.data.map((item: any) => {
        return {
          label: `${item.name}`,
          value: item.id,
        };
      });
      setOptions(getOptions);
    } catch (err) {
      console.warn(err);
      tMsg.warning("Unable to retrieve map options");
      // navigate("/error"); // TODO: put this back after debugging
    }
  };

  useEffect(() => {
    fetchThemeOptions();
  }, []);

  const selectedValues =
    value?.map((v: any) => options?.find((o) => o.value === _.toNumber(v))) ||
    [];

  return (
    <Select
      name={name}
      value={selectedValues}
      className={className}
      onChange={(e) => {
        const obj = { target: { value: e.map((o) => o.value) } };
        onChange(obj);
      }}
      required={required}
      isDisabled={disabled}
      options={options}
      isMulti
    />
  );
};
